import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { notification } from 'antd';
import qs from 'qs';
import { environment } from 'environments/environment_dev';

const AxiosInstance = axios.create({
  baseURL: environment.serverUrl,
});

// ---- REQUEST INTERCEPTOR: Content-Type ----
AxiosInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const isFormData = config.data instanceof FormData;

  if (config.headers) {
    for (const key of Object.keys(config.headers)) {
      if (key.toLowerCase() === 'content-type') {
        delete config.headers[key];
      }
    }

    if (!isFormData) {
      config.headers['Content-Type'] = 'application/json';
    }
  }

  return config;
});

// ---- REQUEST INTERCEPTOR: Auth token + params serializer ----
AxiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (config.url && !config.url.includes('/api/login')) {
      const authToken = localStorage.getItem('authToken');
      if (authToken) {
        config.headers['Authorization'] = `Bearer ${authToken}`;
      }
    }

    config.paramsSerializer = (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });
    };

    return config;
  },
  async (error) => {
    notification.error({
      message: 'Info',
      description: error,
      duration: 20,
    });

    return Promise.reject(error);
  },
);

// ---- RESPONSE INTERCEPTOR ----
AxiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,

  (error) => {
    const { status, data } = error.response || {};
    const config = error?.config;

    if (status === 207) {
      notification.warning({
        message: '',
        description: data.error,
        duration: 20,
      });
    }

    if (
      status === 400 &&
      config?.url !== '/api/login' &&
      config?.url !== '/api/signup'
    ) {
      notification.error({
        message: '',
        description: data?.error || data.message,
        duration: 20,
        className: 'custom-no-icon-notification',
        style: {
          border: '3px solid red',
          borderRadius: '20px',
          color: '#ff4d4f',
        },
      });
    }

    const isAuthRoute = config?.url?.includes('/api/login');

    const skipAuth = config?.skipAuthHandler;
    if (status === 401 && !skipAuth && !isAuthRoute) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('role');
      localStorage.removeItem('roles');
      setTimeout(() => {
        window.location.href = '/';
      }, 4000);
    }

    if (status === 500) {
      notification.error({
        message: `Server is facing issues: ${data.details}`,
        description: data.error,
        duration: 20,
      });
    }

    return Promise.reject(error);
  },
);

export default AxiosInstance;
